import { render } from "./SheetSongEdit.vue?vue&type=template&id=fa9a1e76"
import script from "./SheetSongEdit.vue?vue&type=script&lang=js"
export * from "./SheetSongEdit.vue?vue&type=script&lang=js"
script.render = render

export default script